import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, Input, input } from '@angular/core';
import '@maersk-global/mds-components-core/mc-tag';
import '@maersk-global/mds-components-core/mc-popover';
import { CodeDescription } from '../../models/code-description.model';

@Component({
  selector: 'app-tag-with-overflow',
  imports: [],
  templateUrl: './tag-with-overflow.component.html',
  styleUrl: './tag-with-overflow.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagWithOverflowComponent {
  data = input.required<CodeDescription[] | string[]>();
  appearance = input<'neutral-default' | 'neutral-weak' | 'neutral-inverse' | 'info' | 'success' | 'warning' | 'error'>('neutral-inverse');
  overflowCount = input.required<number>();
  withaction = input<boolean | null>(null);
  @Input() dismiss = (_: string) => {};

  onCloseClicked(code: string) {
    this.dismiss(code);
  }

  isStringArray(data: CodeDescription[] | string[]): data is string[] {
    return typeof data[0] === 'string';
  }
  isCodeDescriptionArray(data: CodeDescription[] | string[]): data is CodeDescription[] {
    return typeof data[0] === 'object' && 'code' in data[0] && 'description' in data[0];
  }
}
